import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "./Button"; // Importing the custom button
import { SafeHtmlParser } from "./SafeHtmlParser";

const SectionLayout5 = ({
	heading,
	body,
	button,
	colour,
	colour2,

	image,
	column1,
	column2,
}) => {
	// Get the optimized Gatsby image
	const gatsbyImage = image ? getImage(image) : null;

	return (
		<section className="py-5 py-lg-7">
			<Container className="h-100">
				{/* Main Layout */}
				<Row className=" g-3  g-lg-7 align-items-lg-center">
					{/* Left Column: Text, Stats, and Button */}
					<Col className="mb-4 mb-md-0 py-md-4 " md={6}>
						<div style={{ color: colour }}>
							{/* Heading */}
							<SafeHtmlParser htmlContent={heading} />
						</div>
						<div className="py-3">
							{/* Body */}
							<SafeHtmlParser htmlContent={body} />
						</div>

						{/* Stats Columns */}
						<Row className="mt-3">
							<Col xs={6}>
								<h4 className="mb-2 " style={{ color: colour2 || colour }}>
									{column1.heading}
								</h4>
								<p>{column1.body}</p>
							</Col>
							<Col xs={6}>
								<h4 className="mb-2 " style={{ color: colour2 || colour }}>
									{column2.heading}
								</h4>
								<p>{column2.body}</p>
							</Col>
						</Row>

						{/* Button */}
						{button && (
							<div className="mt-4">
								<Button
									width="w-100 w-md-auto"
									text={button.title}
									link={button.url}
									colour={colour2 || colour} // Use column1 colour as default button color
									isOutline={true}
								/>
							</div>
						)}
					</Col>

					{/* Right Column: Image */}
					<Col md={6}>
						{gatsbyImage && (
							<div
								className="h-md-100 h-lg-auto  "
								style={{ borderRadius: "12px", overflow: "hidden" }}
							>
								<GatsbyImage
									className="h-md-100 h-lg-auto  w-100"
									image={gatsbyImage}
									alt={heading || "Section Image"}
								/>
							</div>
						)}
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default SectionLayout5;
